import { c as _c } from "react/compiler-runtime";
import type { FC, ReactNode } from "react";
export const MenuSectionLabel: FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className="px-2 pb-1 font-medium text-text-interactive-neutral-faint text-xs uppercase tracking-wide">{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};